import { Button, Grid, Typography } from '@mui/material';
import * as React from 'react';
import ErrorImage from 'assets/images/error-image.png';
import useRoot from 'hooks/use-root';

const ErrorPage = () => {
  const { defaultPage } = useRoot();

  return (
    <Grid
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      height="100%"
      gap="15px"
    >
      <img src={ErrorImage} alt="error-image" width={156} />
      <Typography
        variant="h4"
        fontWeight={500}
        sx={{ maxWidth: '410px', marginBottom: '10px' }}
      >
        Oops! something’s not quite right. We’ll fix it soon.
      </Typography>
      <Button
        onClick={() => {
          window.location.href = defaultPage;
        }}
        variant="contained"
        color="inherit"
        size="large"
        sx={{ color: '#000' }}
      >
        GO TO HOME PAGE
      </Button>
    </Grid>
  );
};

export default ErrorPage;
